import { Injectable } from '@angular/core';
import {
  HttpContextToken,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { GlobalErrorModalService } from '../services/global-error-modal.service';
import { constants } from '../../../constants';

export const BYPASS_HANDLER = new HttpContextToken(() => false);

@Injectable()
export class GlobalErrorInterceptorService implements HttpInterceptor {
  constructor(
    public router: Router,
    private globalErrorModalService: GlobalErrorModalService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // SKIP GLOBAL HANDLER
    if (req.context.get(BYPASS_HANDLER) === true) {
      return next.handle(req);
    }

    return next.handle(req).pipe(
      catchError((error) => {
        if (
          error.status != 401 &&
          error.status != 403 &&
          !(
            [409, 423].includes(error.status) &&
            error.url.includes(constants.uriParts.registerFreemiumUser)
          )
        ) {
          this.globalErrorModalService.open(error.error);
        }
        return throwError(error);
      })
    );
  }
}
